<template>
  <v-menu
    class='select-warehouse-body'
    min-width='220'
    transition="slide-y-transition"
    :close-on-content-click='false'
    offset-y
    v-model='selectorIsOpened'
  >
    <template v-slot:activator="{ on, attrs }">
      <span
        @click="toggleArrow"
        v-bind="attrs"
        v-on="on"
        class="mx-3"
      >
        <span class="topBarItem" v-if="getActiveWarehouse">Active warehouse: <b>{{ getActiveWarehouse.name }}</b></span>
        <span class="topBarItem" v-else>Select Warehouse</span>
        <v-icon v-if="arrowFlag" style="font-size: 1.2rem">mdi-chevron-down</v-icon>
        <v-icon v-else style="font-size: 1.2rem">mdi-chevron-up</v-icon>
      </span>
    </template>
    <div>
      <v-col>
        <v-text-field
          v-model='search'
          placeholder='Search...'
        />
      </v-col>
      <div class='to-selecting-list mt-2'>
        <v-list>
          <v-list-item
            v-for="(item, i) in filtredWarehousesList"
            :key="i"
            @click='doWarehouseActive(item)'
            :class="{'v-list-item--active': item.active}"
          >
            <v-list-item-title>
              <img :src='require("@/assets/icons/svg/warehouse.svg")' style='width: 16px'>
              <span class='warehouse-list-title'>{{ item.name }}</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </div>
      <div v-if='$getRight("warehouseCreate") && $getRight("warehouseView")'>
        <v-col class='mt-2 flex justify-center' v-if='getUsed("warehouses")<getLimit("warehouses")'>
          <v-btn
            color='#7972c0'
            class='add-warehouse-button'
            @click='goAdding'
          >
            <v-icon>mdi-plus</v-icon>
            Add Warehouse
          </v-btn>
        </v-col>
        <v-col class='mt-2 flex justify-center' v-else>
          <v-btn
            color='#7972c0'
            class='add-warehouse-button'
            @click='showUpgradeSubscriptionPlanPopup'
          >
            <v-icon>mdi-plus</v-icon>
            Add Warehouse
          </v-btn>
        </v-col>
      </div>
    </div>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getLimitMixin } from '@/mixins/getLimit'
export default {
  data() {
    return {
      arrowFlag: true,
      search: '',
      selectorIsOpened: false
    }
  },
  mixins: [getLimitMixin],
  computed: {
    ...mapGetters('user', ['getIsOwner']),
    ...mapGetters('warehouses', ['getWarehousesList', 'getActiveWarehouse']),
    filtredWarehousesList() {
      if (this.search) {
        return this.getWarehousesList.filter(item => {
          return item.name.toLowerCase().search(new RegExp(this.search.toLowerCase()), 'g') >= 0
        })
      }
      return this.getWarehousesList
    }
  },
  methods: {
    ...mapActions(['showUpgradeSubscriptionPlanPopup']),
    ...mapActions('warehouses', ['setWarehouseActive']),
    toggleArrow() {
      this.arrowFlag = !this.arrowFlag
    },
    doWarehouseActive(item) {
      if (!item.active) this.$store.commit('warehouses/setWarehouseActive', item.id)
      this.setWarehouseActive(item.id)
      this.selectorIsOpened = false
    },
    goAdding() {
      if (this.$route.name !== 'WarehousesList') {
        this.$router.push({ name: 'WarehousesList' })
      }
      this.$store.commit('warehouses/addWarehousePopup', true)
    }
  }
}
</script>

<style lang='scss'>
  .topBarItem {
    font-size: 14px;
    line-height: 36px;
    cursor: pointer;
    b {
      color: #7671bd;
      font-size: 15px;
      font-weight: bold;
    }
  }
  .select-warehouse-activator {
    span {
      color: #7671bd;
      font-weight: 600;
      justify-content: flex-start;
      text-transform: none;
    }
  }
  .warehouse-list-title {
    margin-left: 5px;
  }
  .v-menu__content--fixed {
    background-color: #fff;
  }
  .to-selecting-list {
    max-height: 180px;
    overflow-y: auto;
  }
  .add-warehouse-button {
    span {
      color: #fff
    }
  }
  .v-list-item--active {
    span.warehouse-list-title {
      color: #7671bd
    }
  }
</style>
